"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteOptionFunction = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const Tag_1 = tslib_1.__importDefault(require("../Tag"));
const capitalizeFirstLetter_1 = require("../_InternalUtils/capitalizeFirstLetter");
/**
 * Takes a functionOption as the only required prop.
 * @param functionOption A function object with the fields name, localizedName, flags and roleType required. This option is only designed to be used when all of these fields are provided.
 * @returns A custom option component for displaying a function - Displaying name, localizedName + tags showing if it is a function/role, readOnly or has a roleType
 * @category component
 */
const AutocompleteOptionFunction = (props) => {
    const { functionOption, readOnlyText, roleText, functionText, roleTypeTexts, ...rest } = (0, styles_1.useThemeProps)({
        props,
        name: "AutocompleteOptionFunction",
    });
    const { name, localizedName, flags, roleType } = functionOption || {};
    return (react_1.default.createElement(ListItem_1.default, { ...rest },
        react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "column" },
            react_1.default.createElement(Typography_1.default, { variant: "body1" }, name),
            react_1.default.createElement(Typography_1.default, { variant: "body1", color: "textSecondary" }, localizedName),
            react_1.default.createElement(Box_1.default, { display: "flex", gap: 1 },
                flags?.includes("role") ? react_1.default.createElement(Tag_1.default, { text: roleText }) : react_1.default.createElement(Tag_1.default, { text: functionText }),
                flags?.includes("role") && roleType && (react_1.default.createElement(Tag_1.default, { text: roleTypeTexts?.[roleType] ? roleTypeTexts[roleType] : (0, capitalizeFirstLetter_1.capitalizeFirstLetter)(roleType) })),
                flags?.includes("readOnly") && react_1.default.createElement(Tag_1.default, { text: readOnlyText })))));
};
exports.AutocompleteOptionFunction = AutocompleteOptionFunction;
